import { MoonLoader } from 'react-spinners';
import { useState, useEffect } from 'react';
import { ModalHistoryAccount } from '../ModalHistoryAccount/ModalHistoryAccount';
import {
  InputDinamycPlaceholder,
  ButtonBasic,
  TextareaDynamicPlaceholder,
  InputSearch
} from '@lk-gtcom/ecomlab-components';
import { ModalProfileExecutor } from './ModalProfileExecutor/ModalProfileExecutor';
import copy_icon from './img/copy_icon.svg';
import useGeneralStore from '../../../store/general';
import { RavshanHttps } from '../../../fetchUrls';
import customHeaders, { getSpace } from '../../../common/headers';
import { TabsGreen } from '../../TabsGreen/TabsGreen';
import { ButtonCopy } from '../../Buttons/ButtonCopy/ButtonCopy';
import { ButtonActionDrop } from '../../Buttons/ButtonActionDrop/ButtonActionDrop';
import { EcexutorRow } from './EcexutorRow/EcexutorRow';
import { SettingsRow } from './SettingsRow/SettingsRow';
import { RoleRow } from './RoleRow/RoleRow';
import ModalWarning from '../ModalWarning/ModalWarning';
import { TokenTab } from './TokenTab/TokenTab';
import './ModalCreatingNewSpace.scss';
import { TitlePage } from '../../TitlePage/TitlePage';
import { TextPage } from '../../TextPage/TextPage';
import { ButtonWithIcon } from '../../Buttons/ButtonWithIcon/ButtonWithIcon';
import { ModalDeleteExecutors } from './ModalDeleteExecutors/ModalDeleteExecutors';
import { usePushNotifications } from '../../../common/pushNotification';
import { useResponseHandler } from '../../../common/auth';
import { useShallow } from 'zustand/react/shallow';

const btn_tab_2 = [
  { label: 'Добавить', value: 'true' },
  { label: 'Добавленные', value: 'false' },
];

const ModalCreatingNewSpace = ({
  setIsModal,
  isEdit = false,
  setIsEditSpace,
  // currentSpace,
  // setCurrentSpace,
  setIsModalActive,
  isModalActive,
  setSelectedSpace,
  setConnectedModal,
  spaceListCurrent,
  fetchSetFavorite,
  fetchSetPin,
  fetchGetSpace
}) => {
  const selectedSpace = useGeneralStore((state) => state.selectedSpace);
  const headers = { ...customHeaders, ...getSpace(selectedSpace) };
  const {
    spaceList,
    // currentSpace,
    // setCurrentSpace,
    accounList,
    setAccountList,
    employeesList,
    setEmployeesList,
    availableEmployeesList,
    setAvailableEmployeesList,
    pageValue1,
    setPageValue1,
    isModalAddEmployees,
    setIsModalAddEmployees,
    setIsModalRole,
    isModalRole,
    setIsAuthorSpase
  } = useGeneralStore();

  const { currentSpace, setCurrentSpace } = useGeneralStore(
    useShallow((state) => ({
      currentSpace: state.currentSpace,
      setCurrentSpace: state.setCurrentSpace
    }))
  );
  const btn_tab_1 = [
    { label: 'Сотрудники', value: 'employee' },
    { label: 'Подключения', value: 'settings' },
    { label: 'Роли', value: 'roles' },
    ...(currentSpace?.is_admin ? [{ label: 'Получить токен', value: 'get_token' }] : []),
  ];

  // Обработка ошибок
  const { addErrorPush, addSuccessPush } = usePushNotifications();
  const { handleTableResponse, handleRequestError } = useResponseHandler();

  const client_id = localStorage.getItem('client_id');
  const [nameSpace, setNameSpace] = useState('');
  const [descriptionSpace, setDescriptionSpace] = useState('');
  const [load, setLoad] = useState(false);

  // Роли
  const [listRole, setListRole] = useState([])


  // const [pageValue1, setPageValue1] = useState(btn_tab_1[0].value);
  const [pageValue2, setPageValue2] = useState(btn_tab_2[1].value);
  const [isFavorite, setIsFavorite] = useState(false);
  const [isPin, setIsPin] = useState(false)
  const [executorSearchValue, setExecutorSearchValue] = useState('')
  const [settingsSearchValue, setSettingsSearchValue] = useState('')
  const [isModalDelete, setIsModalDelete] = useState(false)
  const [currentAccount, setCurrentAccont] = useState(null)
  const [isModalHistory, setIsModalHistory] = useState(false)

  // Modal
  const [isModalDeleteEcecutors, setIsModalDeleteEcecutors] = useState(false)
  const [isModalProfile, setIsModalProfile] = useState(false)

  const [currentMember, setCurrentMember] = useState(null)

  // Добавления пространства
  const fetchAddSpace = () => {
    let url = 'https://apps0.ecomru.ru:4242/api/v2/space/'

    const body = JSON.stringify({
      name: nameSpace,
      description: descriptionSpace,
      is_favorite: isFavorite,
      is_sticky: isPin
    });

    fetch(url, { body, method: 'POST', headers })
      .then(handleTableResponse)
      .then((json) => setTimeout(() => fetchGetSpace(), 500))
      .catch(handleRequestError);
  };

  // Получение информации о пространстве
  const fetchGetCurrentSpace = () => {
    let url = `https://apps0.ecomru.ru:4242/api/v2/space/${selectedSpace?.value}`

    fetch(url, { headers })
      .then(handleTableResponse)
      .then((json) => setCurrentSpace(json))
      .catch(handleRequestError);
  };

  // Изменить пространство
  const fetchChangeSpace = () => {
    let url = `https://apps0.ecomru.ru:4242/api/v2/space/${currentSpace?.id}`

    const body = JSON.stringify({
      name: nameSpace,
      description: descriptionSpace,
      is_favorite: isFavorite,
      is_sticky: isPin
    });

    fetch(url, { body, method: 'PUT', headers })
      .then(handleTableResponse)
      .then((json) => console.log(json))
      .catch(handleRequestError);
  };

  // Получение аккаунтов из пространства
  const fetchGetAccountSpace = () => {
    if (!currentSpace?.id && pageValue2 == 'false') return;

    const abortController = new AbortController();
    setLoad(true);
    const url = `https://apps0.ecomru.ru:4242/api/v2/space/accounts/${currentSpace?.id}`;

    const body = JSON.stringify({
      name: settingsSearchValue
    });

    fetch(url, { headers, method: 'POST', signal: abortController.signal, body })
      .then(handleTableResponse)
      .then((json) => {
        if (json?.data) {
          setAccountList(json?.data);
        }
      })
      .catch(handleRequestError)
      .finally((e) => {
        setLoad(false);
        return abortController;
      });
  };

  // Получение сотрудников из пространства
  const fetchGetClientSpace = (status) => {
    if (!currentSpace?.id) return;
    const abortController = new AbortController();

    const url = `https://apps0.ecomru.ru:4242/api/v2/space/users/${currentSpace?.id}`;

    const body = JSON.stringify({ name: executorSearchValue });
     setLoad(true);

    fetch(url, { headers, method: 'POST', signal: abortController.signal, body })
      .then(handleTableResponse)
      .then((json) => {
        if (json?.data) {
          // "role_id", "role_name"
          setAvailableEmployeesList(json?.data);
        }
      })
      .catch(handleRequestError)
      .finally((e) => {
        setLoad(false);
        return abortController;
      });

  };

  // Получение ролей из пространства
  const fetchGetRoleSpace = () => {
    if (!currentSpace?.id && pageValue2 == 'false') return;

    const abortController = new AbortController();
    setLoad(true);
    const url = `https://apps0.ecomru.ru:4242/api/v2/space/roles/${currentSpace?.id}`;

    fetch(url, { headers, signal: abortController.signal })
      .then(handleTableResponse)
      .then((json) => setListRole(json?.data || []))
      .catch(handleRequestError)
      .finally((e) => {
        setLoad(false);
        return abortController;
      });
  };

  // Добавление аккаунта в пространство
  const fetchAddClientInSpace = (client_id) => {
    const url = `${RavshanHttps}/api/space/client/add`;

    const body = JSON.stringify({
      id: currentSpace?.id,
      clients: client_id,
    });

    fetch(url, { body, method: 'POST', headers })
      .then(handleTableResponse)
      .then((json) => console.log(json))
      .catch(handleRequestError);
  };

  // Удаление аккаунта в пространство
  const fetchDeleteAccountInSpace = (acc_id) => {
    const url = `https://apps0.ecomru.ru:4242/api/v2/account/${acc_id}`;

    fetch(url, { method: 'DELETE', headers })
      .then(handleTableResponse)
      .then((json) => console.log(json))
      .catch(handleRequestError);
  };

  // Удаление сотрудника из пространство
  const fetchDeleteClientInSpace = (client_id) => {
    const url = `https://apps0.ecomru.ru:4242/api/v2/space/users/remove/${currentSpace?.id}`;

    const body = JSON.stringify({ employees: client_id });

    fetch(url, { body, method: 'POST', headers })
      .then(handleTableResponse)
      .then((json) => addSuccessPush('Сотрудник успешно удален из пространства'))
      .catch(handleRequestError);
  };

  // Удаление пространства
  const fetchDeleteSpace = (id) => {
    let url = `${RavshanHttps}/api/space/`

    const body = JSON.stringify({ id: id })

    fetch(url, { body, method: 'DELETE', headers })
      .then(handleTableResponse)
      .then((json) => console.log(json))
      .catch(handleRequestError)

  }

  const btns = [
    {
      btn: 'Удалить', func: () => {
        fetchDeleteSpace(currentSpace?.id)
        setIsModal(false)
      }
    },
  ];

  useEffect(() => {
    if (!isModalAddEmployees && !isModalDeleteEcecutors && !isModalActive && !isModalProfile) {
      if (pageValue1 === 'employee') {
        setTimeout(() => fetchGetClientSpace(), 100)
      } else {
        fetchGetAccountSpace();
      }
    }
  }, [pageValue1, isModalAddEmployees, isModalDeleteEcecutors, isModalActive, isModalProfile, currentSpace]);

  useEffect(() => {
    if ((pageValue1 === 'employee') && executorSearchValue) {
      fetchGetClientSpace();
    }
  }, [executorSearchValue]);

  useEffect(() => {
    if ((pageValue1 !== 'employee') && settingsSearchValue) {
      fetchGetAccountSpace();
    }
  }, [settingsSearchValue]);

  const [selectedArrAccount, setSelectedArrAccount] = useState([]);


  useEffect(() => {
    if (!isModalActive) {
      setTimeout(() => fetchGetAccountSpace(), 100)
    }
  }, [isModalActive]);

  useEffect(() => {
    if (pageValue1 == 'roles' && !isModalRole) {
      setTimeout(() => fetchGetRoleSpace(), 100)
    }
  }, [pageValue1, isModalRole]);


  useEffect(() => {
    if (spaceListCurrent) {
      const filter_space = spaceListCurrent?.filter((el) => el?.id == currentSpace?.id)
      const current_space = filter_space?.map((el) => {
        return {
          author: el.author,
          labelValue: el.name,
          value: el.id
        }
      })
      if (current_space?.[0]) {
        setSelectedSpace(current_space?.[0])
        setIsAuthorSpase(currentSpace?.author?.id == client_id)
      } else {
        setAccountList([])
        setAvailableEmployeesList([])
        setDescriptionSpace('')
      }
    } else {

    }
  }, [currentSpace]);

  useEffect(() => {
    if (currentSpace?.name) {
      setNameSpace(currentSpace?.name)
      setDescriptionSpace(currentSpace?.description)
      setIsPin(currentSpace?.is_sticky)
      setIsFavorite(currentSpace?.is_favorite)
    }
  }, [currentSpace]);

  useEffect(() => {
    return () => {
      setIsEditSpace(false);
      setCurrentSpace(null);
      setAccountList([]);
      setEmployeesList([])
      setAvailableEmployeesList([])
      setIsModal(false);
    }
  }, []);

  useEffect(() => {
    if (isEdit && !currentSpace?.name) {
      fetchGetCurrentSpace()
    }
  }, [selectedSpace]);

  return (
    <>
      {/* Профиль сотрудника */}
      {isModalProfile &&
        <ModalProfileExecutor
          currentMember={currentMember}
          setIsModal={setIsModalProfile}
          setCurrentMember={setCurrentMember}
        />}

      {isModalDeleteEcecutors && <ModalDeleteExecutors
        availableEmployeesList={availableEmployeesList}
        setIsModal={setIsModalDeleteEcecutors}
        currentMember={currentMember}
        setCurrentMember={setCurrentMember}
        deleteMember={fetchDeleteClientInSpace}
      />}


      {isModalDelete && <ModalWarning
        headerText='Удалить подключение'
        approveButtonText='Удалить'
        cancelButtonText='Отмена'
        colorBtn='red'
        onApproveClick={() => {
          fetchDeleteAccountInSpace(currentAccount.id);
          setTimeout(() => {
            fetchGetAccountSpace()
            setCurrentAccont(null)
            setIsModalDelete(false)
          }, 1000);
        }}
        onCancelClick={() => setIsModalDelete(false)}
      />}

      {isModalHistory &&
        <ModalHistoryAccount
          setIsModal={setIsModalHistory}
        />}

      <>
        {currentSpace?.name && <TitlePage
          title={currentSpace?.name}
        />}
        <div className="modal-creating-new-space">
          <div className="modal-creating-new-space__header">
            {currentSpace?.id && <div className='modal-creating-new-space__id'>
              <ButtonCopy
                value={currentSpace?.id}
                style={{ position: 'relative' }}
                top={'200%'}
                icon={copy_icon}
              />
              {`ID-${currentSpace?.id}`}
            </div>}
            <TitlePage
              medium
              title={isEdit
                ?
                (currentSpace?.is_admin ? `Редактирование пространства ` : '')
                :
                'Создание нового пространства'
              }
            />

            {(currentSpace?.is_admin || currentSpace?.is_admin === undefined)
              &&
              <InputDinamycPlaceholder
                changeValue={currentSpace?.name}
                placeholder="Название"
                onChange={(e) => setNameSpace(e)}
                size='s'
              />}

            <ButtonWithIcon
              whiteGreen
              size='m'
              favorite
              changeValue={isFavorite}
              onClick={(e) => {
                fetchSetFavorite(currentSpace?.id, !isFavorite)
                setIsFavorite(!isFavorite)
              }}
              style={{ marginLeft: 'auto' }}
            />

            <ButtonWithIcon
              pin
              whiteGreen
              size='m'
              changeValue={isPin}
              onClick={(e) => {
                fetchSetPin(currentSpace?.id, !isFavorite)
                setIsPin(!isPin)
              }}
            />

            {(currentSpace?.is_admin || !isEdit) &&
              <ButtonActionDrop id={1} btns={btns} />}
          </div>

          {(currentSpace?.is_admin && isEdit) ? <TextareaDynamicPlaceholder
            changeValue={descriptionSpace}
            width={'100%'}
            placeholder={'Введите описание для пространства'}
            onChange={(e) => setDescriptionSpace(e)}
          />
            : (descriptionSpace && <TextPage
              text={<>{descriptionSpace || 'Отсутствует'}</>}
            />)
          }

          <TabsGreen
            btns={btn_tab_1}
            currentBtn={pageValue1}
            setCurrentBtn={(e) => {
              setPageValue1(e)
            }}
            checkValue={true}
          />

          <div className="modal-creating-new-space__content">
            {(pageValue1 == 'employee') && <>

              {(currentSpace?.is_admin && isEdit) && <ButtonBasic
                green
                text="Добавить сотрудника +"
                onClick={(e) => setIsModalAddEmployees(true)}
                width="200px"
                size="32px"
              />
              }

              <InputSearch
                placeholder="Найти сотрудника"
                onChange={(e) => setExecutorSearchValue(e)}
              />
            </>}

            {pageValue1 == 'settings' &&
              <>
                <div className="modal-creating-new-space__btn-group">
                  {(currentSpace?.is_admin && isEdit) &&
                    <ButtonBasic
                      green
                      text="Добавить подключение +"
                      onClick={(e) => setIsModalActive(true)}
                      width="200px"
                      size="32px"
                    />}

                  <ButtonBasic
                    blue
                    text="История изменений"
                    onClick={(e) => {
                      setIsModalHistory(true)
                    }}
                    width="200px"
                    size="32px"
                  />
                </div>


                <InputSearch
                  placeholder="Поиск..."
                  value={settingsSearchValue}
                  onChange={(e) => setSettingsSearchValue(e)}
                />
              </>
            }

            {load ?
              <div
                className="center"
                style={{
                  width: '100%',
                  height: '100%',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
              >
                <MoonLoader size={40} color="#7b7b7b" speedMultiplier={0.5} />
              </div>
              :
              <>


                {pageValue1 == 'employee' && <div className="modal-creating-new-space__content-executor">
                  {availableEmployeesList.map(
                    (el) => {
                      return (
                        <EcexutorRow
                          setIsModal={setIsModalProfile}
                          id={el.id}
                          role_id={el.role_id}
                          role_name={el.role_name}
                          isAdmin={currentSpace?.is_admin}
                          login={el.login}
                          name={el.name}
                          color={el.color}
                          status={false}
                          setCurrentMember={setCurrentMember}
                          deleteMember={(e) => {
                            if (currentSpace?.id) {
                              setCurrentMember(el)
                              setIsModalDeleteEcecutors(true)
                              // fetchDeleteClientInSpace(e);
                            }
                          }}
                        />
                      );
                    }
                  )}
                </div>}


                {pageValue1 == 'settings' && <div className="modal-creating-new-space__content-settings">
                  {accounList?.map(
                    (el) => {
                      return (
                        <SettingsRow
                          id={el?.id}
                          setConnectedModal={setConnectedModal}
                          setIsModal={setIsModalActive}
                          icon={el?.portal?.icon}
                          name={el?.name}
                          status={el?.status}
                          mp_name={el?.marketplace?.name}
                          mp_group={el?.marketplace?.group}
                          access={el?.access}
                          isAdmin={currentSpace?.is_admin}
                          btnFunc={() => {
                            if (currentSpace?.id) {
                              setCurrentAccont(el)
                              setIsModalDelete(true)
                            } else {
                              let list_executor = selectedArrAccount;
                              let current_list_executor =
                                list_executor.filter(
                                  (item) => item.id != el?.id
                                );
                              setSelectedArrAccount(current_list_executor);
                            }
                          }}
                        />
                      );
                    }
                  )}
                </div>}

                {pageValue1 == 'roles' &&
                  <>
                    {currentSpace?.is_admin &&
                      <ButtonBasic
                        green
                        text="Добавить роль +"
                        onClick={(e) => setIsModalRole(true)}
                        width="200px"
                        size="32px"
                      />}
                  </>
                }

                {pageValue1 == 'roles' &&
                  listRole?.map((el) => {
                    return <RoleRow
                      key={el?.id}
                      update={fetchGetRoleSpace}
                      isAdmin={currentSpace?.is_admin}
                      setIsModalRole={setIsModalRole}
                      {...el}
                    />
                  })

                }

                {pageValue1 == 'get_token' &&
                  <TokenTab />
                }
              </>
            }
          </div>

          {(currentSpace?.is_admin || !isEdit) && <div className="modal-creating-new-space__btn-box">
            <ButtonBasic
              green
              onClick={(e) => {
                if (isEdit) {
                  fetchChangeSpace();
                } else {
                  fetchAddSpace();
                }
                setCurrentSpace(null);
                setAccountList([]);
                setEmployeesList([]);
                setIsModal(false);
              }}
              text={isEdit ? 'Сохранить изменения' : 'Создать'}
              disabled={!nameSpace}
            />
          </div>}
        </div>
      </>
    </>
  );
};

export { ModalCreatingNewSpace };
